var styles = {"media-breakpoint-sm":"(min-width: 40em)","mediaBreakpointSm":"(min-width: 40em)","message-bubble":"styles_message-bubble__M_5zY inline-block","messageBubble":"styles_message-bubble__M_5zY inline-block","flat":"styles_flat__IlM8H","full-width":"styles_full-width__1KNFo","fullWidth":"styles_full-width__1KNFo","sent":"styles_sent__17d7s","received":"styles_received__LQQLT"};

export default styles;
//# sourceMappingURL=styles.css.js.map
